import request from '@/utils/request'

//学生端-进入考试(抽取实验)
export function vrExamineStudentExtract(data) {
	return request({
		url: '/vr/vrExamine/vrExamineStudentExtract',
		method: 'get',
		params: data
	})
}

//学生端-实验考试列表
export function vrExamineStudentList(data) {
	return request({
		url: '/vr/vrExamine/vrExamineStudentList',
		method: 'get',
		params: data
	})
}

//学生端-实验考试2.0 判断是否提交
export function vrExamineDataIsCommit(data) {
	return request({
		url: '/vr/vrExamineData/vrExamineDataIsCommit',
		method: 'get',
		params: data
	})
}

//学生端-实验考试1.0 判断是否提交
export function vrExaminePaperUserInit(data) {
	return request({
		url: '/vr/vrExaminePaper/vrExaminePaperUserInit',
		method: 'get',
		params: data
	})
}

//学生端-实验考试1.0 查看成绩
export function getresult(data) {
	return request({
		url: '/vr/vrExaminePaper/getresult',
		method: 'get',
		params: data
	})
}

//学生端-实验考试2.0 查看成绩
export function userDataStepList(data) {
	return request({
		url: '/vr/vrExamineDataStep/userDataStepList',
		method: 'get',
		params: data
	})
}



